<template>
  <component :is="nameSuccessView" />
</template>

<script lang="ts" setup>
import { useSuccessTransactionView } from './useSuccessTransactionView';

defineOptions({ name: 'SuccessTransactionView' });

const { nameSuccessView } = useSuccessTransactionView();
</script>
